// extracted by mini-css-extract-plugin
module.exports = {"footer__form":"BatchMessageForm_footer__form__3kM3T","btn__footer":"BatchMessageForm_btn__footer__3HB1E","text__default":"BatchMessageForm_text__default__gM5fW"};